import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  boxAdjustmentStyle: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '25%', // 4 columns
    minHeight: scale(80), // Ensure minimum height for text
    paddingBottom: scale(8), // Add padding at bottom for text
  },
  fltLstContainerStyle: {
    flex: 1,
    justifyContent: 'space-between',
    marginVertical: scale(5),
    paddingBottom: scale(10),
    paddingHorizontal: scale(6),
  },
  singTileStyle: { flex: 1, justifyContent: 'center' },
  topProductsList: { flex: 1 },
});

export default styles;
